export const SET_SEARCH_FOWARD_CONTACT = "SET_SEARCH_FOWARD_CONTACT";
export const SET_FOWARD_CONTACT = "SET_FOWARD_CONTACT";
export const SET_FOREX = "SET_FOREX";
export const SET_SELECTED_SEARCH_DATA = "SET_SELECTED_SEARCH_DATA";
export const SET_FOWARD_CONTACT_SELECT_ID = "SET_FOWARD_CONTACT_SELECT_ID";
export const ADD_FOREX_IN_FOWARD_CONTACT = "ADD_FOREX_IN_FOWARD_CONTACT";
export const EDIT_FOREX_IN_FOWARD_CONTACT = "EDIT_FOREX_IN_FOWARD_CONTACT";
export const SET_FOREX_SELECT_ID = "SET_FOREX_SELECT_ID";
export const SET_FOREXS_DATA = "SET_FOREX_DATA";
export const ADD_MASTER_SUPPLIER_DATA = "ADD_MASTER_SUPPLIER_DATA";
export const SET_MASTER_SUPPLIER = "SET_MASTER_SUPPLIER";
export const EDIT_MASTER_SUPPLIER = "EDIT_MASTER_SUPPLIER";
export const SET_SEARCH_SUPPLIER = "SET_SEARCH_SUPPLIER";
export const EDIT_PAPER_GRADE_NAME = "EDIT_PAPER_GRADE_NAME";
export const Add_PAPER_GRADE = "Add_PAPER_GRADE";
export const DELETE_PAPER_GRADE = "DELETE_PAPER_GRADE";
export const SET_BRAND = "EDIT_BRAND";
export const Add_BRAND = "Add_BRAND";
export const Add_COUNTRY = "Add_COUNTRY";
export const Add_PAYMENT_TERMS = "Add_PAYMENT_TERMS";
export const SET_DEFAULT_PAYMENT_TERM = "SET_DEFAULT_PAYMENT_TERM";
export const DELETE_BRAND = "DELETE_BRAND";
export const DELETE_COUNTRY = "DELETE_COUNTRY";
export const DELETE_PORT = "DELETE_PORT";
export const DELETE_PAYMENT_TERMS = "DELETE_PAYMENT_TERMS";
export const EDIT_SEARCH_SUPPLIER = "EDIT_SEARCH_SUPPLIER";
export const DELETE_MASTER_SUPPLIER = "DELETE_MASTER_SUPPLIER";
export const ADD_SEARCH_SUPPLIER = "ADD_SEARCH_SUPPLIER";
export const SET_ACCOUNT_DATA = "SET_ACCOUNT_DATA";
export const SET_SEARCH_SHIPMENT_DETAIL = "SET_SEARCH_SHIPMENT_DETAIL";
export const EDIT_SEARCH_SHIPMENT_DETAIL = "EDIT_SEARCH_SHIPMENT_DETAIL";
export const SET_SEARCH_CLAIM_CCR = "SET_SEARCH_CLAIM_CCR";
export const UPDATE_SEARCH_CLAIM_CCR = "UPDATE_SEARCH_CLAIM_CCR";
export const ADD_SELECTED_CLAIM_CCR = "ADD_SELECTED_CLAIM_CCR";
export const Remove_SELECTED_CLAIM_CCR = "Remove_SELECTED_CLAIM_CCR";
export const UPDATE_SELECTED_CLAIM_CCR = "UPDATE_SELECTED_CLAIM_CCR";
export const SET_VIEW_MODE = "SET_VIEW_MODE";
export const SET_SELECTED_CLAIM_CCR = "SET_SELECTED_CLAIM_CCR";
export const SET_SEARCH_CLAIM = "SET_SEARCH_CLAIM";
export const UPDATE_SEARCH_CLAIM = "UPDATE_SEARCH_CLAIM";
export const UPDATE_SEARCH_CLAIM_CRITERIA = "UPDATE_SEARCH_CLAIM_CRITERIA";
export const SET_SEARCH_CLAIM_CRITERIA = "SET_SEARCH_CLAIM_CRITERIA";
export const SET_SEARCH_DOCUMENT_CLAIM = "SET_SEARCH_DOCUMENT_CLAIM";
export const CLEAR_CLAIM_CREATE_DATA = "CLEAR_CLAIM_CREATE_DATA";
export const SET_CLAIMPROBLEM = "SET_CLAIMPROBLEM";
export const SET_SEARCH_FROM_TOS = "SET_SEARCH_FROM_TOS";
export const SET_MODE_CLAIM_TOS = "SET_MODE_CLAIM_TOS";
export const SET_CLAIM_CREATE_MODE = "SET_CLAIM_CREATE_MODE";
export const UPDATE_SEARCH_CCR_UNSELECTE = "UPDATE_SEARCH_CCR_UNSELECTE";
export const UPDATE_SEARCH_CLAIM_TOS_UNSELECT =
  "UPDATE_SEARCH_CLAIM_TOS_UNSELECT";
export const UPDATE_SEARCH_CLAIM_TOS = "UPDATE_SEARCH_CLAIM_TOS";
export const SET_ANNOUCEMENT = "SET_ANNOUCEMENT";
export const Add_PORT = "Add_PORT";
export const EDIT_ANNOUCEMENT = "EDIT_ANNOUCEMENT";
export const REMOVE_ANNOUCEMENT = "REMOVE_ANNOUCEMENT";
export const SET_CLAIM_COUNT_TASK = "SET_CLAIM_COUNT_TASK";
export const SET_LAYOUT = "SET_LAYOUT";
export const SET_LOADING = "SET_LOADING";
export const SET_CLAIM_SELECTED_MATERIAL_CONFIRM =
  "SET_CLAIM_SELECTED_MATERIAL_CONFIRM";
export const SET_PAGE_NAME_LAYOUT = "SET_PAGE_NAME_LAYOUT";
export const SET_HANGEFIRE = "SET_HANGEFIRE";
export const SET_HANGEFIRE_READY_STATUS = "SET_HANGEFIRE_READY_STATUS";
export const SET_HOME_DATA = "SET_HOME_DATA";
export const SET_ANNOUCEMENT_HOME_DATA = "SET_ANNOUCEMENT_HOME_DATA";
export const SET_CLAIM_SELECTED_MATERIAL = "SET_CLAIM_SELECTED_MATERIAL";
export const SET_MASTER_TB_DATA = "SET_MASTER_TB_DATA";
export const UPDATE_MASTER_TB = "UPDATE_MASTER_TB";
export const REMOVE_MASTER_TB = "REMOVE_MASTER_TB";
export const SET_ORDER_TASK = "SET_ORDER_TASK";
export const SET_CLAIM_SELECTED_MANUAL = "SET_CLAIM_SELECTED_MANUAL";
export const REMOVE_CLAIM_SELECTED_MAUNAL = "REMOVE_CLAIM_SELECTED_MAUNAL";
export const EDIT_CLAIM_SELECTED_MANUAL = "EDIT_CLAIM_SELECTED_MANUAL";
export const ADD_CLAIM_SELECTED_MANUAL = "ADD_CLAIM_SELECTED_MANUAL";
export const UPDATE_FOREX_HISTORY = "UPDATE_FOREX_HISTORY";
export const SET_SEARCH_LIST_TOS = "SET_SEARCH_LIST_TOS";
export const REMOVE_FOREX_HISTORY = "REMOVE_FOREX_HISTORY";
export const SET_TOS_TASK = "SET_TOS_TASK";
export const SET_LIST_TOS_TASK = "SET_LIST_TOS_TASK";
export const SET_DRAFT_CLAIM_CREATE_CONFIRM = "SET_DRAFT_CLAIM_CREATE_CONFIRM";
export const SET_MASTER_PAYMENT_TERM = "SET_MASTER_PAYMENT_TERM";
